import Vue from 'vue';
import gaService from './ga.service';

export default {
    async openSession() {
        gaService.send('games', 'tvbet', 'tvbet');
        return (await Vue.http.post('/api/tvbet/session/open', {})).data;
    },
    async openDemoSession() {
        gaService.send('games', 'tvbet', 'tvbet demo');
        return (await Vue.http.post('/api/tvbet/session/opendemo', {})).data;
    },
    async closeSession() {
        return (await Vue.http.post('/api/tvbet/session/close')).data;
    }
};



// WEBPACK FOOTER //
// ./_common/services/tvbet.service.js